// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"15125":"4ffac73f12c81be55e82","25825":"9a3fbea494cb42804952","80020":"e019b4e09c7960abe6c5"}[chunkId] + ".css";
};